// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes fadeInMixin {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes fadeOutMixin {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
.CustomChartLegend {
  display: flex;
  flex-direction: row;
  padding: 0 var(--spacing_unit_4);
  margin-top: var(--spacing_unit_3);
  margin-bottom: var(--spacing_unit_3);
}
.CustomChartLegend.right, .CustomChartLegend.left {
  flex-direction: column;
}
.CustomChartLegend .CustomChartLegend-list {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  column-gap: 12px;
  row-gap: var(--spacing_unit_3);
}
.CustomChartLegend .CustomChartLegend-item {
  all: unset;
  display: flex;
  align-items: center;
  gap: 3px;
  cursor: pointer;
  max-width: 160px;
}
.CustomChartLegend .CustomChartLegend-item.inactive {
  opacity: 0.45;
}
.CustomChartLegend .CustomChartLegend-item .CustomChartLegend-item-icon {
  border-radius: 50%;
  flex-shrink: 0;
}
.CustomChartLegend .CustomChartLegend-item .CustomChartLegend-item-text {
  color: rgb(55, 61, 63);
  font-size: 12px;
  font-weight: 400;
  margin: 0;
  display: -webkit-box;
  line-clamp: 1;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  word-break: break-word;
  word-break: break-all;
}
.CustomChartLegend .CustomChartLegend-more-text {
  color: rgb(55, 61, 63);
  font-size: 12px;
}
.CustomChartLegend .CustomChartLegend-more-text:hover {
  opacity: 0.8;
}
.CustomChartLegend .CustomChartLegend-menu {
  width: -webkit-max-content;
  width: -moz-max-content;
  width: max-content;
  max-height: 350px;
  display: grid;
  overflow-y: scroll;
}
.CustomChartLegend .CustomChartLegend-menu::-webkit-scrollbar {
  width: 7px;
  height: 7px;
}
.CustomChartLegend .CustomChartLegend-menu::-webkit-scrollbar-track {
  background: transparent;
}
.CustomChartLegend .CustomChartLegend-menu::-webkit-scrollbar-thumb {
  background: var(--color_neutral_200);
  height: 80px;
  border-radius: 50px;
}
.CustomChartLegend .CustomChartLegend-menu:hover::-webkit-scrollbar-thumb {
  background: var(--color_neutral_400);
}
.CustomChartLegend .CustomChartLegend-menu::-webkit-scrollbar-thumb:active {
  background: var(--color_neutral_500);
}
.CustomChartLegend .CustomChartLegend-menu li,
.CustomChartLegend .CustomChartLegend-menu li > button {
  width: 100%;
}
.CustomChartLegend .CustomChartLegend-menu li:hover .CustomChartLegend-item-text,
.CustomChartLegend .CustomChartLegend-menu li > button:hover .CustomChartLegend-item-text {
  color: #fff;
}`, "",{"version":3,"sources":["webpack://./src/mixins.scss","webpack://./src/components/CustomChartLegend/index.scss"],"names":[],"mappings":"AAwCA;EACE;IACE,UAAA;ECvCF;EDyCA;IACE,UAAA;ECvCF;AACF;AD0CA;EACE;IACE,UAAA;ECxCF;ED0CA;IACE,UAAA;ECxCF;AACF;AAbA;EACE,aAAA;EACA,mBAAA;EACA,gCAAA;EACA,iCAAA;EACA,oCAAA;AAeF;AAbE;EAEE,sBAAA;AAcJ;AAXE;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,8BAAA;AAaJ;AAVE;EACE,UAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;AAYJ;AAVI;EACE,aAAA;AAYN;AATI;EACE,kBAAA;EACA,cAAA;AAWN;AARI;EACE,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,SAAA;ED1CJ,oBAAA;EACA,aC2CwB;ED1CxB,qBC0CwB;EDzCxB,4BAAA;EACA,gBAAA;EACA,sBANoC;EC8ChC,qBAAA;AAcN;AAVE;EACE,sBAAA;EACA,eAAA;AAYJ;AAVI;EACE,YAAA;AAYN;AARE;EACE,0BAAA;EAAA,uBAAA;EAAA,kBAAA;EACA,iBAAA;EACA,aAAA;EACA,kBAAA;AAUJ;AD3DE;EACE,UAAA;EACA,WAAA;AC6DJ;AD1DE;EACE,uBAAA;AC4DJ;ADzDE;EACE,oCAdM;EAeN,YAAA;EACA,mBAAA;AC2DJ;ADvDI;EACE,oCApBS;AC6Ef;ADrDE;EACE,oCAxBY;AC+EhB;AAzBI;;EAEE,WAAA;AA2BN;AAxBQ;;EACE,WAAA;AA2BV","sourcesContent":["@mixin line-clamp($lines, $wordBreak: break-word) {\n  display: -webkit-box;\n  line-clamp: $lines;\n  -webkit-line-clamp: $lines;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  word-break: $wordBreak;\n}\n\n@mixin scrollbar(\n  $color: var(--color_neutral_200),\n  $colorHover: var(--color_neutral_400),\n  $colorActive: var(--color_neutral_500)\n) {\n  &::-webkit-scrollbar {\n    width: 7px;\n    height: 7px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: transparent;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: $color;\n    height: 80px;\n    border-radius: 50px;\n  }\n\n  &:hover {\n    &::-webkit-scrollbar-thumb {\n      background: $colorHover;\n    }\n  }\n\n  &::-webkit-scrollbar-thumb:active {\n    background: $colorActive;\n  }\n}\n\n@keyframes fadeInMixin {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n@keyframes fadeOutMixin {\n  0% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n\n@mixin fadeIn($timing, $length, $delay, $fill) {\n  animation: fadeInMixin $timing $length $delay;\n  animation-fill-mode: $fill;\n}\n\n@mixin fadeOut($timing, $length, $delay, $fill) {\n  animation: fadeOutMixin $timing $length $delay;\n  animation-fill-mode: $fill;\n}\n\n@mixin noise {\n  position: relative;\n  &::after {\n    content: '';\n    position: absolute;\n    inset: 0;\n    z-index: -1;\n    background-image: url('./assets/images/png/noise.png');\n    background-position: 0% 0%;\n    background-size: 36.23046875px 36.23046875px;\n    background-repeat: repeat;\n    border-radius: 12px;\n    opacity: 0.3;\n  }\n}\n\n@mixin scoped-excluded($selector, $exclude-class) {\n  :is(#{$selector}):not(:where(#{$exclude-class} *)) {\n    @content;\n  }\n}\n","@import 'src/mixins';\n\n.CustomChartLegend {\n  display: flex;\n  flex-direction: row;\n  padding: 0 var(--spacing_unit_4);\n  margin-top: var(--spacing_unit_3);\n  margin-bottom: var(--spacing_unit_3);\n\n  &.right,\n  &.left {\n    flex-direction: column;\n  }\n\n  .CustomChartLegend-list {\n    display: flex;\n    align-items: center;\n    flex-wrap: nowrap;\n    column-gap: 12px;\n    row-gap: var(--spacing_unit_3);\n  }\n\n  .CustomChartLegend-item {\n    all: unset;\n    display: flex;\n    align-items: center;\n    gap: 3px;\n    cursor: pointer;\n    max-width: 160px;\n\n    &.inactive {\n      opacity: 0.45;\n    }\n\n    .CustomChartLegend-item-icon {\n      border-radius: 50%;\n      flex-shrink: 0;\n    }\n\n    .CustomChartLegend-item-text {\n      color: rgb(55, 61, 63);\n      font-size: 12px;\n      font-weight: 400;\n      margin: 0;\n\n      @include line-clamp(1);\n      word-break: break-all;\n    }\n  }\n\n  .CustomChartLegend-more-text {\n    color: rgb(55, 61, 63);\n    font-size: 12px;\n\n    &:hover {\n      opacity: 0.8;\n    }\n  }\n\n  .CustomChartLegend-menu {\n    width: max-content;\n    max-height: 350px;\n    display: grid;\n    overflow-y: scroll;\n    @include scrollbar;\n\n    li,\n    li > button {\n      width: 100%;\n\n      &:hover {\n        .CustomChartLegend-item-text {\n          color: #fff;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
